export type ContentProps = {
	selectedIssuesFlaggedState: SelectedIssueFlaggedState;
	onToggleFlag: (value: boolean) => void;
	canFlag: boolean;
};

export type Props = {
	cardIds: number[];
};

export const SelectedIssueFlaggedState = {
	ALL_FLAGGED: 'ALL_FLAGGED',
	NONE_FLAGGED: 'NONE_FLAGGED',
	INDETERMINATE: 'INDETERMINATE',
} as const;
export type SelectedIssueFlaggedState =
	(typeof SelectedIssueFlaggedState)[keyof typeof SelectedIssueFlaggedState];
